import { get, post, put, patch, del } from '../http/http';
// API分组
export default {
    getList: (val) => get('/api/group', val), // 查询列表
    getListData: (val) => get('/api/group/my-group', val), //查询列表
    addList: (val) => post('/api/group', val), // 添加
    delList: (val) => del(`/api/group/${val}`), // 删除
    getInfo: (val) => get(`/api/group/${val}`), // 查询详情
    putList: (val) => put(`/api/group/${val.id}`, val), // 编辑
    domain: (val) => post('/api/group/domain', val), // 绑定域名
    putEnv: (val) => put('/api/group/domain', val), // 更改域名
    // getInfoList:(val) =>get(`/api/${val}`), // 查询api明细列表
    // groupDeitalDomain: (val) => post('/api/group/domain', val) //api分组明细页 绑定域名
    delDomain: (val) => del(`/api/group/${val.id}/domain`, val), // 删除域名
    certificate: (val) => post('/api/group/certificate', val), // 上传证书
    getInfoList: (id) => get(`/api/group/${id}`), // 查询详情列表
    getProductApigroup: (id) => get(`/api/group/my-group/${id}`) // 查询用户所创建的所有的已上架API分组下的api 。。
}